import { useEffect } from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { NAVERWORKS_SUPPORT_IMAGE_EXT } from '../../define/naverworksDefine';
import { getNaverWorksFile } from '../../extApis/naverWorksApi';
import IconProgress from '../../img/naverWorksFileIcon/img_loading.gif';

const IconImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ThumbnailImage = styled.img`
  width: 118px;
  height: 118px;
`;

const IconImage = styled.img`
  width: 48px;
  height: 48px;
  margin-top: 36px;
  margin-bottom: 7px;
`;

const ProgressIcon = styled.img`
  width: 50px;
  height: 20px;
  bottom: 7px;
`;

export default function NaverWorksIcon({ type, driveId, fileId, fileExt, defaultImage }) {
  const initState = {
    isThumbnail: false,
    iconImage: null
  };

  const [iconState, setIconState] = useState(initState);
  const [isDownloading, setIsDownloading] = useState(false);

  const getImage = async () => {
    try {
      if (Object.keys(NAVERWORKS_SUPPORT_IMAGE_EXT).includes(fileExt)) {
        setIsDownloading(true);
        const { data } = await getNaverWorksFile(type, driveId, fileId, true);
        return `data:${NAVERWORKS_SUPPORT_IMAGE_EXT[fileExt].mimeType};base64,${Buffer.from(
          data
        ).toString('base64')}`;
      } else {
        return defaultImage;
      }
    } catch (error) {
      throw error;
    } finally {
      setIsDownloading(false);
    }
  };

  useEffect(() => {
    if (!iconState.iconImage) {
      getImage(type, driveId, fileId, fileExt)
        .then((res) => {
          setIconState({ isThumbnail: true, iconImage: res });
        })
        .catch(() => {
          setIconState(initState);
        });
    }
  }, [type, driveId, fileId, fileExt]);

  return (
    <>
      {iconState.isThumbnail && <ThumbnailImage src={iconState.iconImage || defaultImage} />}
      {iconState.isThumbnail === false && (
        <IconImageWrapper>
          <IconImage src={defaultImage} />
          {isDownloading && <ProgressIcon src={IconProgress} />}
        </IconImageWrapper>
      )}
    </>
  );
}
